var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modules-settings-vendors-list" }, [
    _c("div", { staticClass: "nav-section" }, [
      _c(
        "a",
        {
          staticClass: "nav-back",
          on: {
            click: function ($event) {
              return _vm.navToVendorTab()
            },
          },
        },
        [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("action.backToVendorTab")) + "\n    "
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("label", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("settings.user.vendor.all"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { display: "inline", "vertical-align": "middle" } },
      [
        _c("span", [
          _vm._v(
            _vm._s(_vm.$t("total")) +
              ": " +
              _vm._s(_vm.orderedItems.length) +
              " / " +
              _vm._s(_vm.recordCounts)
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _vm.aclHelper.getSettingsUpdateAccess()
      ? _c(
          "div",
          { staticClass: "controls" },
          [
            _c("AddVendor", {
              attrs: {
                companyList: _vm.items,
                departmentList: _vm.departmentNames,
                parent: "allVendors",
              },
            }),
            _vm._v(" "),
            _c(
              "DialogSlot",
              {
                ref: "invite-vendor-modal",
                attrs: {
                  id: "settings-users-contractor-invite-admin",
                  modalBtn: _vm.$t("action.invite"),
                  modalHeader: _vm.$t("action.sendInvitation"),
                  disableBtn: !_vm.orderedItems.length,
                  showCloseBtn: false,
                },
              },
              [
                _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                  _c(
                    "div",
                    [
                      _c("label", { staticClass: "required-flag" }, [
                        _vm._v(_vm._s(_vm.$t("company.basic.companyName"))),
                      ]),
                      _vm._v(" "),
                      _c("HKLSelect", {
                        staticClass: "align-center",
                        attrs: {
                          value: _vm.userToInviteId,
                          options: _vm.allUserHklOptions,
                          showSearch: true,
                          placeholder: "",
                        },
                        on: { change: _vm.onInviteUserChange },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "new-multiselect" },
                    [
                      _c("label", { staticClass: "required-flag" }, [
                        _vm._v(_vm._s(_vm.$t("company.basic.departmentName"))),
                      ]),
                      _vm._v(" "),
                      _c("HKLMultiSelect", {
                        staticClass: "align-center multi-value",
                        attrs: {
                          options: _vm.userToInviteDepartmentHklOptions,
                          showSearch: false,
                          placeholder: "",
                        },
                        model: {
                          value: _vm.selectedDepartmentIds,
                          callback: function ($$v) {
                            _vm.selectedDepartmentIds = $$v
                          },
                          expression: "selectedDepartmentIds",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("label", { staticClass: "required-flag" }, [
                        _vm._v(_vm._s(_vm.$t("settings.user.vendor.username"))),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.usersToInvite, function (user, index) {
                        return _c("span", { key: user.id }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(user.username) +
                              _vm._s(
                                index === _vm.usersToInvite.length - 1
                                  ? ""
                                  : ","
                              ) +
                              "\n          "
                          ),
                        ])
                      }),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--orange",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.closeModal()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("action.cancel")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--darkblue",
                      attrs: {
                        type: "button",
                        disabled:
                          !_vm.userToInvite.username ||
                          _vm.usersToInvite.length === 0,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.sendInvitation()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("action.invite")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "tender-table" }, [
      _c("table", [
        _c("thead", [
          _c(
            "tr",
            _vm._l(_vm.itemHeaders, function (header, index) {
              return _c(
                "th",
                {
                  key: index,
                  class: header.class,
                  on: {
                    click: function ($event) {
                      return _vm.sortBy(header.code)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t(header.name)) +
                      " " +
                      _vm._s(
                        _vm.orderbyAttr === header.code
                          ? _vm.reverse
                            ? "▼"
                            : "▲"
                          : null
                      ) +
                      "\n          "
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _c("tr", [
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.itemHeaders[0].filter,
                      expression: "itemHeaders[0].filter",
                    },
                  ],
                  staticClass: "setting-users-filter-search",
                  attrs: {
                    id: "settings-users-contractor-search-company",
                    type: "text",
                  },
                  domProps: { value: _vm.itemHeaders[0].filter },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.itemHeaders[0],
                        "filter",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.itemHeaders[1].filter,
                      expression: "itemHeaders[1].filter",
                    },
                  ],
                  staticClass: "setting-users-filter-search",
                  attrs: {
                    id: "settings-users-contractor-search-company",
                    type: "text",
                  },
                  domProps: { value: _vm.itemHeaders[1].filter },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.itemHeaders[1],
                        "filter",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "settings-filter align-center" },
                [
                  _c("HKLSelect", {
                    staticClass: "align-center",
                    attrs: {
                      value: _vm.itemHeaders[2].filter,
                      "settings-filter-row": "",
                      options: _vm.departmentHklOptions,
                      showSearch: false,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        _vm.itemHeaders[2].filter = val
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.itemHeaders[3].filter,
                      expression: "itemHeaders[3].filter",
                    },
                  ],
                  staticClass: "setting-users-filter-search",
                  attrs: {
                    id: "settings-users-contractor-search-username",
                    type: "text",
                  },
                  domProps: { value: _vm.itemHeaders[3].filter },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.itemHeaders[3],
                        "filter",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "settings-filter align-center" },
                [
                  _c("HKLSelect", {
                    staticClass: "align-center",
                    attrs: {
                      value: _vm.itemHeaders[4].filter,
                      "settings-filter-row": "",
                      options: _vm.statusHklOptions,
                      showSearch: false,
                      placeholder: "",
                    },
                    on: {
                      change: function (val) {
                        _vm.itemHeaders[4].filter = val
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { attrs: { colspan: "2" } }),
            ]),
            _vm._v(" "),
            _vm._l(_vm.orderedItems, function (item, index) {
              return _c("tr", { key: index }, [
                _c("td", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.navToDetail(item.id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.id))]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.navToDetail(item.id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n            " + _vm._s(item.department) + "\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", { staticClass: "align-left" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(item.user.username) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm._f("customStatusLabel")(_vm.showStatus(item)))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", [
                    _vm._v(_vm._s(_vm.formatDate(item.user.lastLoginAt))),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", [
                    _vm._v(_vm._s(_vm.formatDate(item.user.invitedAt))),
                  ]),
                ]),
              ])
            }),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }